import React, { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { canAccessSection, landingPathFor } from "../constants/contentSections";
import { useT } from "../i18n";

interface SectionRouteProps {
  /** Content section key. Omitted for admin-only pages (Users, Deals). */
  section?: string;
  children: ReactNode;
}

/**
 * Keeps a marketer out of pages they were not granted, including when they
 * type the URL directly. Full admins pass through untouched.
 */
const SectionRoute = ({ section, children }: SectionRouteProps) => {
  const { user } = useAuth();
  const t = useT();

  if (canAccessSection(user as any, section)) return <>{children}</>;

  const landing = landingPathFor(user as any);
  if (landing === "/no-access") {
    return (
      <div className="flex flex-col items-center justify-center py-24 text-center">
        <i className="fa-solid fa-lock text-gray-300 text-5xl mb-4"></i>
        <p className="text-gray-600 font-medium">{t("layout.noAccess.title")}</p>
        <p className="text-sm text-gray-400 mt-1">
          {t("layout.noAccess.subtitle")}
        </p>
      </div>
    );
  }
  return <Navigate to={landing} replace />;
};

export default SectionRoute;
